//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'
import { ScopeBaseGrid } from '../common/common.base.grid.controller'

import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { ConfigHelper } from '../../helpers'

import { SUPPLIER_SERVICE_NAME, SupplierService } from '../../services/supplier'
import { SERVICES_MODULE_NAME } from './../../services'
import {
    $STATE_SERVICE_PROVIDER_NAME,
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    SYSTEM_SERVICE_PROVIDER_NAME,
    SYSTEM_SERVICE_NAME,
    SystemServiceProvider,
    SystemService
} from '../../services/system'

import {
    USER_SESSION_SERVICE_NAME,
    USER_SESSION_SERVICE_PROVIDER_NAME,
    UserSessionService,
    UserSessionServiceProvider
} from '../../services/user-session'

import { SuppliersController } from './suppliers.controller'

//#region Asset Imports

import * as TEMPLATE from './suppliers.tpl.html'
import { SupplierDetailsDirective } from './details/supplier-details.directive'
import { SupplierCreateEditDirective } from './create-edit/supplier-create-edit.directive'
import { COMPONENTS_MODULE_NAME } from './components'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'SuppliersController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'supplierCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'supplierDetails'
const MENU_INDEX = 10
const MODULE_NAME: string = 'simax.suppliers'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'SUPPLIER_NAME'
const STATE_NAME: string = 'suppliers'
const STATE_URL: string = '/suppliers'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [
    commonModule,
    apiModule,
    SERVICES_MODULE_NAME,
    COMPONENTS_MODULE_NAME
])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    SUPPLIER_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    (
        $scope: ScopeBaseGrid,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        suppliersService: SupplierService,
        systemService: SystemService,
        userSessionService: UserSessionService
    ) => new SuppliersController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        suppliersService,
        systemService,
        userSessionService,
        SupplierService.REFERENCE_TYPE,
        SupplierService.SIMAX_MODULE_NAME
    )])

module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new SupplierCreateEditDirective()])
module.directive(DETAILS_DIRECTIVE_NAME, [() => new SupplierDetailsDirective()])

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionServiceProvider: UserSessionServiceProvider,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Supplier_IdSupplier',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionServiceProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.SUPPLIER_LIST)
                && !loggedOperator.hasPermission(Activity.SUPPLIER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SupplierModule)) {
                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.AIRPORT_SHUTTLE),
                    'suppliers',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME